<template>
<div>
  <div v-if="isSearch">
    <div style="margin-left:20px;display:flex;justify-content:center;align-items:center;width:60%;">
      <p style="white-space:nowrap;text-align:center;">请录入收货库存编码/订单号</p>
      <el-input type="text" v-model="orderNo" style="flex:1;padding:20px;"></el-input>
      <el-button type="primary" @click="getQualitySearch()">查询</el-button>
    </div>
    <div style="margin-left:220px;color:red;">
      <span v-if="hasError">录入收货库存编码/订单号有误，请确认后重新录入</span>
    </div>
  </div>
  <div v-if="!isSearch">
    <div style="margin-bottom:10px">
      <span >质检机器条形：{{this.editModelEvalForm.repertoryCode}}</span>

      <span style="margin-left:60px">质检关联订单：{{this.editModelEvalForm.orderNo}}</span>
    </div>

    <div class="content">
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editModelEvalForm"
            :model="editModelEvalForm"
            :rules="editorFormRules"
            label-width="100px"
            label-position="left"
          >
            <el-form-item label="分类" prop="categoryId">
              <el-select
                clearable
                v-model="editModelEvalForm.categoryId"
                placeholder="请选择"
                @change="getBrandOptions()"
              >
                <el-option
                  v-for="item in queryCategoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌" prop="brandId">
              <el-select
                clearable
                v-model="editModelEvalForm.brandId"
                placeholder="请选择"
                @change="getModelList()"
              >
                <el-option
                  v-for="item in editBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机型" prop="modelId">
              <el-select
                clearable
                v-model="editModelEvalForm.modelId"
                filterable
                placeholder="请选择"
                @change="getModelEvalParam()"
              >
                <el-option
                  v-for="item in editModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="IMEI">
              <el-input clearable v-model="editModelEvalForm.imei"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="24"> <span>物品信息</span>&nbsp;&nbsp; </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row style="border: 1px color black;" v-if="isItemRefresh">
              <el-col :span="24">
                <query-price-option
                  v-for="(item, index) in itemValueList"
                  :key="index"
                  :index="index"
                  type="1"
                  :eval-value-object="item"
                  @getCildrenValue="getCildrenValue"
                ></query-price-option>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="24"> <span>成色信息</span>&nbsp;&nbsp; </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row style="border: 1px color black;" v-if="isConditionRefresh">
              <el-col :span="24">
                <query-price-option
                  v-for="(item, index) in conditionValueList"
                  :key="index"
                  :index="index"
                  type="2"
                  :eval-value-object="item"
                  @getCildrenValue="getCildrenValue"
                ></query-price-option>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="24"> <span>功能信息</span>&nbsp;&nbsp; </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row style="border: 1px color black;" v-if="isFunctionRefresh">
              <el-col :span="24">
                <query-price-option
                  v-for="(item, index) in functionValueList"
                  :key="index"
                  :index="index"
                  type="3"
                  :eval-value-object="item"
                  @getCildrenValue="getCildrenValue"
                ></query-price-option>
              </el-col>
            </el-row>
            <el-divider></el-divider>

            <el-form-item label="质检备注">
            </el-form-item>
            <el-form>
              <el-row style="border: 1px color black;" >
              <el-col :span="24">
                <query-price-option
                  v-for="(item, index) in qualityRemarkValueList"
                  :key="index"
                  :index="index"
                  type="3"
                  :eval-value-object="item"
                  @getCildrenValue="getCildrenValue"
                ></query-price-option>
              </el-col>
            </el-row>
              <el-row>
                <el-form-item span="24">
                  <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="请输入"
                    v-model="editModelEvalForm.qualityRemark"
                  >
                  </el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="质检结果" prop="inspectionResult">
                  <el-radio v-model="editModelEvalForm.inspectionResult" :label="0" >质检通过</el-radio>
                  <el-radio v-model="editModelEvalForm.inspectionResult" :label="1">质检不通过</el-radio>
                </el-form-item>
              </el-row>
            </el-form>


          </el-form>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center;margin-top:10px">
        <el-button type="primary" @click="submitEditor">提交质检结果</el-button>
        <el-button style="margin: 10px 20px;" @click="returnBack()">返回</el-button>
    </div>

  </div>


</div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      itemOptionsArray: this.global.itemOptions,
      orderNo: "",
      userType: 0,
      userInfo: {},
      hasError: false,
      isSearch: true,
      editModelEvalForm: {
        orderNo: null,
        id: null,
        value: null,
        name: null,
        categoryId: null,
        modelId: null,
        serviceId: null,
        brandId: null,
        conditionParam: [],
        functionParam: [],
        modelParam: [],
        inspectionResult: 0,
        userId:null,
        repertoryCode: null,
        imei:null,
        qualityRemark:null,
      },
      queryCategoryOptions: [],
      // queryCategoryOptions: [
      //   { id: 1, name: "分类1" }, // 这里需要设置每个选项的 id 和 name
      //   { id: 2, name: "分类2" },
      //   // 其他选项...
      // ],
      editModelList: [],
      editBrandOptions: [],

      itemTemplateValueByBrand: {},

      //物品信息可变框
      itemCheckList: [],
      itemValueList: [],
      isItemRefresh: true,

      //成色信息可变框
      conditionCheckList: [],
      conditionValueList: [],
      isConditionRefresh: true,

      //功能信息可变框
      functionValueList: [],
      isFunctionRefresh: true,
      functionCheckList: [],

      //质检备注信息
      //quality_remark_item
      qualityRemarkValueList: [],
      //functionCheckList: [],
      isQualityRemarkRefresh: true,

      //成色值选项
      conditionValueOptions: [],
      //功能值选项
      functionValueOptions: [],

      //质检备注选项
      qualityRemarkValueOptions: [],

      editorFormRules: {
        modelId: [{ required: true, message: "请输入机型", trigger: "change" }],
        brandId: [{ required: true, message: "请选择品牌", trigger: "change" }],
        categoryId: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    getQualitySearch(){
      console.log("getQualitySearch");
      let self = this;
      this.$api
        .getQualitySearch({
          orderNo: this.orderNo,
        })
        .then((res) => {
          if(res.data == null){
              this.hasError = true;
          }else{
              this.editModelEvalForm.orderNo = res.data.orderNO;
              this.editModelEvalForm.imei = res.data.imei;
              this.editModelEvalForm.repertoryCode = res.data.repertoryCode;
              this.editModelEvalForm.qualityRemark = res.data.qualityRemark;
              //把对应的值赋值给对应的变量
              this.editModelEvalForm.categoryId = res.data.categoryId;
              this.getBrandOptions();
              this.editModelEvalForm.brandId = res.data.brandId;
              this.getModelList();
              this.editModelEvalForm.modelId = res.data.modelId;
              this.getModelEvalParam();
              this.hasError = false;
              this.isSearch = false;
          }
        });
    },
    returnBack(){
      console.log("returnBack");
      this.isSearch = true;

    },
    getCategroyOptions() {
      console.log("getCategroyOptions");
      let self = this;
      this.$api
        .getTemplateValue({
          typeKey: "category",
        })
        .then((res) => {
          self.queryCategoryOptions = res.data || [];
        });
    },
    getBrandOptions() {
      console.log("getBrandOptions");
      this.resetFrom();
      let categoryId = this.editModelEvalForm.categoryId;
      console.log(categoryId);
      this.$set(this.editModelEvalForm, "modelId", null);
      this.$set(this.editModelEvalForm, "brandId", null);
      if (categoryId === "") {
        this.$set(this, "editBrandOptions", []);
        this.$set(this, "editModelList", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            categoryId: categoryId,
            typeKey: "phoneBrand",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.editBrandOptions = res.data.records || [];
          });
      }
    },

    //机型
    getModelList() {
      this.resetFrom();
      console.log("getModelList");
      let brandId = this.editModelEvalForm.brandId;
      if (brandId === "") {
        this.$set(this, "editModelList", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            brandId: brandId,
            typeKey: "phoneModal",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.editModelList = res.data.records || [];
          });
      }
    },
        //重置表单
    resetFrom() {
      this.conditionValueOptions = [];
      this.functionValueOptions = [];
      this.qualityRemarkValueOptions = [];
      this.itemCheckList = [];
      this.functionCheckList = [];
      this.conditionCheckList = [];
      this.itemValueList = [];
      this.conditionValueList = [];
      this.functionValueList = [];
      this.qualityRemarkValueList = [];
      this.itemTemplateValueByBrand = {};
    },
    //根据分类ID，获取等级评估信息
    getModelEvalParam() {
      let self = this;
      self.resetFrom();
      if (
        this.editModelEvalForm.categoryId == null ||
        this.editModelEvalForm.categoryId == "" ||
        this.editModelEvalForm.brandId == null ||
        this.editModelEvalForm.brandId == "" ||
        this.editModelEvalForm.modelId == null ||
        this.editModelEvalForm.modelId == ""
      ) {
        return;
      }
      this.$api
        .priceQueryParam({
          categoryId: this.editModelEvalForm.categoryId,
          brandId: this.editModelEvalForm.brandId,
          modelId: this.editModelEvalForm.modelId,
        })
        .then((res) => {
          self.evalModelParam = res.data || {};
          self.conditionValueOptions = self.evalModelParam.conditionValues;
          self.functionValueOptions = self.evalModelParam.functionValues;
          //添加质检备注
          self.qualityRemarkValueOptions = self.evalModelParam.qualityRemarkValues;
          self.itemTemplateValueByBrand = self.evalModelParam.brandSkuTreeDTO;

          self.itemOptionsArray.forEach((item) => {
            self.showOrHiddenItemValue(item);
          });
          self.conditionValueOptions.forEach((item) => {
            if(item.children!=null&&item.children.length>0){
              item.children.forEach((e) => {
                        e.selected = false;
                      });
              self.showOrHiddenConditionValue(item);
            }
          });
          self.functionValueOptions.forEach((item) => {
              if(item.children!=null&&item.children.length>0){
                item.children.forEach((e) => {
                  e.selected = false;
                });
                self.showOrHiddenFunctionValue(item);
              }
          });
          self.qualityRemarkValueOptions.forEach((item) => {
              if(item.children!=null&&item.children.length>0){
                item.children.forEach((e) => {
                  e.selected = false;
                });
                self.showOrHiddenQualityRemarkValue(item);
              }
          });
        });
    },
    //显示或隐藏成色选项
    showOrHiddenConditionValue(item) {
      let itemTemp = {
        id: null,
        name: null,
        multipleChoice: null,
        children: [],
        selected: false,
      };
      itemTemp.id = item.id;
      itemTemp.name = item.name;
      itemTemp.multipleChoice = item.multipleChoice;
      itemTemp.children = item.children;
      this.conditionValueList.push(itemTemp);
      this.isConditionRefresh = false;
      let self = this;
      this.$nextTick((e) => {
        self.isConditionRefresh = true;
      });
    },
    //显示或隐藏功能选项
    showOrHiddenFunctionValue(item) {
      let itemTemp = {
        id: null,
        name: null,
        multipleChoice: null,
        children: [],
        selected: false,
      };
      itemTemp.id = item.id;
      itemTemp.name = item.name;
      itemTemp.multipleChoice = item.multipleChoice;
      itemTemp.children = item.children;
      this.functionValueList.push(itemTemp);

      this.isFunctionRefresh = false;
      let self = this;
      this.$nextTick((e) => {
        self.isFunctionRefresh = true;
      });
    },
    //显示或隐藏质检备注选项
    showOrHiddenQualityRemarkValue(item) {
      let itemTemp = {
        id: null,
        name: null,
        multipleChoice: null,
        children: [],
        selected: false,
      };
      itemTemp.id = item.id;
      itemTemp.name = item.name;
      itemTemp.multipleChoice = item.multipleChoice;
      itemTemp.children = item.children;
      this.qualityRemarkValueList.push(itemTemp);

      this.isQualityRemarkRefresh = false;
      let self = this;
      this.$nextTick((e) => {
        self.isQualityRemarkRefresh = true;
      });
    },
    //显示或隐藏物品选项
    showOrHiddenItemValue(item) {
      let itemTemp = {
        id: null,
        name: null,
        multipleChoice: null,
        children: [],
        selected: false,
      };
      itemTemp.id = item.id;
      itemTemp.name = item.name;
      itemTemp.multipleChoice = 1;
      if(this.itemTemplateValueByBrand === null){
        return
      }else{
        if (item.id === "sku_memory") {
              itemTemp.children = this.itemTemplateValueByBrand.skuMemory;
            } else if (item.id === "sku_purchase_channel") {
              itemTemp.children = this.itemTemplateValueByBrand.skuPurchaseChannel;
            } else if (item.id === "sku_body_color") {
              itemTemp.children = this.itemTemplateValueByBrand.skuBodyColor;
            } else if (item.id === "sku_warranty_duration") {
              itemTemp.children = this.itemTemplateValueByBrand.skuWarrantyDuration;
            } else if (item.id === "sku_small_model") {
              itemTemp.children = this.itemTemplateValueByBrand.skuSmallModel;
            } else if (item.id === "sku_network") {
              itemTemp.children = this.itemTemplateValueByBrand.skuNetwork;
            }else if (item.id === "sku_cpu") {
              itemTemp.children = this.itemTemplateValueByBrand.skuCpu;
            }else if (item.id === "sku_graphics_card") {
              itemTemp.children = this.itemTemplateValueByBrand.skuGraphicsCard;
            }else if (item.id === "sku_solid_drive") {
              itemTemp.children = this.itemTemplateValueByBrand.skuSolidDrive;
            }else if (item.id === "sku_mechanical_drive") {
              itemTemp.children = this.itemTemplateValueByBrand.skuMechanicalDrive;
            }else if (item.id === "sku_charging_interface") {
              itemTemp.children = this.itemTemplateValueByBrand.skuChargingInterface;
            }else if (item.id === "sku_charging_method") {
              itemTemp.children = this.itemTemplateValueByBrand.skuChargingMethod;
            }else if (item.id === "sku_case_size") {
              itemTemp.children = this.itemTemplateValueByBrand.skuCaseSize;
            }else if (item.id === "sku_case_material") {
              itemTemp.children = this.itemTemplateValueByBrand.skuCaseMaterial;
            }else if (item.id === "sku_watch_strap") {
              itemTemp.children = this.itemTemplateValueByBrand.skuWatchStrap;
            }else if (item.id === "sku_strap_color") {
              itemTemp.children = this.itemTemplateValueByBrand.skuStrapColor;
            }else if (item.id === "sku_left_right_ear") {
              itemTemp.children = this.itemTemplateValueByBrand.skuLeftRightEar;
            }else if (item.id === "sku_external_keyboard") {
              itemTemp.children = this.itemTemplateValueByBrand.skuExternalKeyboard;
            }else if (item.id === "sku_accessories_situation") {
              itemTemp.children = this.itemTemplateValueByBrand.skuAccessoriesSituation;
            }
      }
      if(itemTemp.children==null || itemTemp.children.length<=0){
        return
      }
      itemTemp.children.forEach((e) => {
        e.selected = false;
      });
      this.itemValueList.push(itemTemp);
      this.isItemRefresh = false;
      let self = this;
      this.$nextTick((e) => {
        self.isItemRefresh = true;
      });
    },
    //获取子组件的值
    getCildrenValue(index, type, evalValueObject) {
      if (type === 1) {
        this.itemValueList[index] = evalValueObject;
      } else if (type === 2) {
        this.conditionValueList[index] = evalValueObject;
      } else if (type === 3) {
        this.functionValueList[index] = evalValueObject;
      } else if (type == 4) {
        this.qualityRemarkValueList[index] = evalValueObject;
      }
    },

    // 提交编辑
   async submitEditor() {
      let self = this;
      this.$refs["editModelEvalForm"].validate((valid) => {
        if (valid) {
          let params = this.editModelEvalForm;
          this.itemValueList.forEach((item) => {
            if (item.id === "sku_memory") {
              this.itemTemplateValueByBrand.skuMemory = item.children;
            } else if (item.id === "sku_purchase_channel") {
              this.itemTemplateValueByBrand.skuPurchaseChannel = item.children;
            } else if (item.id === "sku_body_color") {
              this.itemTemplateValueByBrand.skuBodyColor = item.children;
            } else if (item.id === "sku_warranty_duration") {
              this.itemTemplateValueByBrand.skuWarrantyDuration = item.children;
            } else if (item.id === "sku_small_model") {
              this.itemTemplateValueByBrand.skuSmallModel = item.children;
            } else if (item.id === "sku_network") {
              this.itemTemplateValueByBrand.skuNetwork = item.children;
            }else if (item.id === "sku_cpu") {
              this.itemTemplateValueByBrand.skuCpu  = item.children;
            }else if (item.id === "sku_graphics_card") {
               this.itemTemplateValueByBrand.skuGraphicsCard  = item.children;
            }else if (item.id === "sku_solid_drive") {
               this.itemTemplateValueByBrand.skuSolidDrive  = item.children;
            }else if (item.id === "sku_mechanical_drive") {
               this.itemTemplateValueByBrand.skuMechanicalDrive  = item.children;
            }else if (item.id === "sku_charging_interface") {
               this.itemTemplateValueByBrand.skuChargingInterface = item.children;
            }else if (item.id === "sku_charging_method") {
              this.itemTemplateValueByBrand.skuChargingMethod= item.children;
            }else if (item.id === "sku_case_size") {
              this.itemTemplateValueByBrand.skuCaseSize= item.children;
            }else if (item.id === "sku_case_material") {
              this.itemTemplateValueByBrand.skuCaseMaterial= item.children;
            }else if (item.id === "sku_watch_strap") {
              this.itemTemplateValueByBrand.skuWatchStrap= item.children;
            }else if (item.id === "sku_strap_color") {
              this.itemTemplateValueByBrand.skuStrapColor= item.children;
            }else if (item.id === "sku_left_right_ear") {
              this.itemTemplateValueByBrand.skuLeftRightEar= item.children;
            }else if (item.id === "sku_external_keyboard") {
              this.itemTemplateValueByBrand.skuExternalKeyboard= item.children;
            }else if (item.id === "sku_accessories_situation") {
              this.itemTemplateValueByBrand.skuAccessoriesSituation= item.children;
            }
          });
          if(this.itemValueList.length>0){
            this.itemTemplateValueByBrand.phoneModel = null;
          }
          params.modelParam = JSON.stringify(this.itemTemplateValueByBrand);
          params.conditionParam = JSON.stringify(this.conditionValueList);
          params.functionParam = JSON.stringify(this.functionValueList);
          params.qualityRemarkParam = JSON.stringify(this.qualityRemarkValueList);
          console.log("params");
          console.log(params);
          self.$api.qualityCommit(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: this.editModelEvalForm.orderNo + "已完成质检",
                type: "success",
              });
              this.isSearch = true;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },


  },
  created() {
  },
  mounted() {
    let self = this;
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')).data
    // 是否开启修改
    this.userType = this.userInfo.roleId === 1 ? 1 : 0
    this.getCategroyOptions();

  },

}
</script>
<style lang="less" scoped>
.content {
  background-color: white;
  padding: 20px;
}
</style>
